import React from "react";
import { Text, Button, ModalBody, ModalFooter } from "@nef/core";

import StyledWarningModal from "../../../../styles/WarningModal.styles";

const WarningModal = (props: any) => {
  const { isModalOpen, setModalOpen } = props;
  return (
    <>
      <StyledWarningModal
        data-testid='warningModal'
        className="warning-modal"
        size="lg"
        closeOnOutsideClick={true}
        isOpen={isModalOpen}
        toggle={() => {
          setModalOpen(false);
        }}
      >
        <ModalBody>
          <Text data-testid='warningModalInfo'>
            This process is to be completed by an officer of the fund.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
          data-testid='warningModalBtn'
            color="primary"
            onClick={() => {
              setModalOpen(false);
            }}
          >
            OK
          </Button>
        </ModalFooter>
      </StyledWarningModal>
    </>
  );
};

export default WarningModal;
